import React, { useEffect, useMemo, useState } from 'react';
import { useToast } from '../context/ToastContext';
import { adminListaEspera, adminActualizarLista, resumenLista, mensajeLista, mensajeTesterAceptado, resumenTester, listaComoCSV, ESTADOS_LISTA, TIPOS_LISTA } from '../services/listaEsperaService';
import { linkWhatsAppA } from '../utils/compartir';

const fecha = (f) => new Date(f).toLocaleDateString('es-HN', { day: 'numeric', month: 'short' });

// Admin → Lista de espera del lanzamiento (sql/147): quién se apuntó, de qué
// pieza vino, qué le duele, y escribirle por WhatsApp con un toque.
export default function AdminListaEspera() {
  const { mostrarToast } = useToast();
  const [filas, setFilas] = useState(null);
  const [abierta, setAbierta] = useState(false);
  const [filtro, setFiltro] = useState('todas');

  const cargar = () => adminListaEspera().then(setFilas).catch((e) => { setFilas([]); mostrarToast(e.message, 'error'); });
  useEffect(() => { cargar(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const r = useMemo(() => resumenLista(filas || []), [filas]);
  const visibles = (filas || []).filter((f) => filtro === 'todas' || (filtro === 'testers' ? f.registro === 'tester' : f.estado === filtro));

  const cambiar = async (f, estado) => {
    try {
      const nueva = await adminActualizarLista(f.id, estado);
      setFilas((l) => l.map((x) => (x.id === f.id ? nueva : x)));
    } catch (e) { mostrarToast(e.message, 'error'); }
  };
  const escribir = (f) => {
    const texto = f.estado === 'tester_aceptado' ? mensajeTesterAceptado(f) : mensajeLista(f);
    window.open(linkWhatsAppA(f.whatsapp, texto), '_blank', 'noopener');
    if (f.estado === 'nueva') cambiar(f, 'contactada');
  };
  const descargar = () => {
    const blob = new Blob(['﻿' + listaComoCSV(filas || [])], { type: 'text/csv;charset=utf-8' });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = `lista-espera-kontrol-${new Date().toISOString().slice(0, 10)}.csv`;
    a.click();
    URL.revokeObjectURL(a.href);
  };

  if (!filas) return null;

  return (
    <div className="k-card" style={{ padding: '14px', marginBottom: '14px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
        <b>📝 Lista de espera · abre el 13 de diciembre</b>
        <span style={{ display: 'flex', gap: '6px' }}>
          <button className="k-btn-soft" onClick={cargar}>🔄</button>
          {filas.length > 0 && <button className="k-btn-soft" onClick={descargar}>⬇️ CSV</button>}
          <button className="k-btn-soft" onClick={() => setAbierta(!abierta)}>{abierta ? 'Ocultar' : 'Ver lista'}</button>
        </span>
      </div>
      <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', margin: '10px 0 4px', fontSize: '13px' }}>
        <span><b style={{ fontSize: '22px' }}>{r.total}</b> en la lista</span>
        <span><b style={{ fontSize: '22px' }}>{r.semana}</b> esta semana</span>
        {r.porTipo.map(([k, n]) => <span key={k}>{TIPOS_LISTA[k] || k}: <b>{n}</b></span>)}
        <span>🧪 Testers: <b>{r.testers}</b> postulados · <b>{r.testersAceptados}</b> de 10 aceptados</span>
      </div>
      {r.total > 0 && (
        <div style={{ fontSize: '12.5px', color: '#6B7280', display: 'grid', gap: '2px' }}>
          <span>De dónde vienen: {r.porOrigen.slice(0, 6).map(([k, n]) => `${k} (${n})`).join(' · ')}</span>
          <span>Lo que más les cuesta: {r.porDolor.filter(([k]) => k !== 'sin dato').slice(0, 3).map(([k, n]) => `${k} (${n})`).join(' · ') || '—'}</span>
        </div>
      )}
      {r.total === 0 && <p style={{ margin: '6px 0 0', fontSize: '13px', color: '#6B7280' }}>Todavía nadie. El enlace para compartir es automatikaia.com/lista (agrega ?o=nombre-de-la-pieza para saber de dónde vienen).</p>}

      {abierta && filas.length > 0 && (
        <>
          <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', margin: '12px 0 6px' }}>
            {[{ clave: 'todas', txt: 'Todas' }, { clave: 'testers', txt: '🧪 Postulaciones de testers' }, ...ESTADOS_LISTA].map((e) => (
              <button key={e.clave} className="k-btn-soft" onClick={() => setFiltro(e.clave)}
                style={{ fontSize: '12.5px', fontWeight: filtro === e.clave ? 800 : 500, borderColor: filtro === e.clave ? '#6D28D9' : undefined }}>
                {e.txt}
              </button>
            ))}
          </div>
          {visibles.map((f, i) => (
            <div key={f.id} style={{ display: 'flex', gap: '10px', alignItems: 'center', padding: '8px 0', borderTop: '1px solid #F3F0FA', flexWrap: 'wrap', fontSize: '13px' }}>
              <span style={{ width: '28px', color: '#9CA3AF', fontWeight: 700 }}>#{(filas.indexOf(f) + 1) || i + 1}</span>
              <span style={{ flex: 1, minWidth: '200px' }}>
                {f.registro === 'tester' && <span title="Se postuló como tester" style={{ marginRight: '4px' }}>🧪</span>}<b>{f.nombre}</b>{f.negocio ? ` (${f.negocio})` : ''} · {TIPOS_LISTA[f.tipo] || '—'}{f.rubro ? ` · ${f.rubro}` : ''}{f.pais && f.pais !== 'Honduras' ? ` · ${f.pais}` : ''}
                <span style={{ display: 'block', color: '#6B7280' }}>{f.whatsapp} · {fecha(f.creado_en)} · {f.origen || 'directo'}{f.dolor ? ` · "${f.dolor}"` : ''}</span>
                {f.registro === 'tester' && <span style={{ display: 'block', color: '#0F766E' }}>{resumenTester(f.respuestas)}{f.respuestas?.por_que ? ` · "${f.respuestas.por_que}"` : ''}</span>}
              </span>
              <select value={f.estado} onChange={(e) => cambiar(f, e.target.value)} aria-label={`Estado de ${f.nombre}`}
                style={{ padding: '6px 8px', borderRadius: '8px', border: '1px solid #E5E7EB', fontSize: '12.5px', color: ESTADOS_LISTA.find((e) => e.clave === f.estado)?.color }}>
                {ESTADOS_LISTA.map((e) => <option key={e.clave} value={e.clave}>{e.txt}</option>)}
              </select>
              <button onClick={() => escribir(f)} className="k-btn-soft" style={{ background: '#25D366', color: '#fff', border: 'none', fontWeight: 700 }}>WhatsApp</button>
            </div>
          ))}
        </>
      )}
    </div>
  );
}
